/* eslint-disable consistent-return */
import React, {
  useCallback, useEffect, useRef, useState,
} from 'react';
import './StyleNotification.scss';
import { useDispatch, useSelector } from 'react-redux';
import { CircularProgress } from '@mui/material';
import { MessageIcon } from '../../assets/NavBarIcons';
import { RootState } from '../../redux/rootState';
import { formatDateToMMDDYY } from '../../utils/CommonFunctions';
import {
  clearExpenseNotification, getExpenseNotifications, getExpenseNotificationsSuccess, resetClearSuccess,
} from './redux/dashboardSlice';
import { ExpenseNotification, ExpenseNotificationsData } from './utils/TypeDashboard';
import { setLoader } from '../../redux/loaderSlice';

function ScreenExpenseNotification() {
  const dispatch = useDispatch();
  const containerRef = useRef<HTMLDivElement>(null);
  const {
    expenseNotifications, isClearSuccess, isClearNotificationLoading, isExpNotificationsLoading,
  } = useSelector((state: RootState) => state.dashboardReducer);

  const [page, setPage] = useState(1);
  const [data, setData] = useState<ExpenseNotification[]>([]);
  const [isFetching, setIsFetching] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  const handleScroll = useCallback(() => {
    const container = containerRef.current;
    if (!container || isFetching || !hasMore) return;

    const { scrollTop, scrollHeight, clientHeight } = container;
    if (scrollTop + clientHeight >= scrollHeight - 10) {
      setIsFetching(true);
      setPage((prev) => prev + 1);
    }
  }, [isFetching, hasMore]);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    container.addEventListener('scroll', handleScroll);
    return () => container.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  useEffect(() => {
    if (page === 1) return; // initial data already loaded from header
    dispatch(getExpenseNotifications({ pageNumber: page, pageSize: 10 }));
  }, [page]);

  useEffect(() => {
    setIsFetching(false);
    if (!expenseNotifications?.Expenses) return;

    let appendData = [];
    if (page === 1) {
      appendData = expenseNotifications?.Expenses;
      setData(appendData);
    } else {
      appendData = [...data, ...(expenseNotifications?.Expenses || [])];
      setData(appendData);
    }

    if (appendData.length >= expenseNotifications?.TotalCount) {
      setHasMore(false);
    }
  }, [expenseNotifications]);

  useEffect(() => {
    dispatch(getExpenseNotificationsSuccess({} as ExpenseNotificationsData));
    dispatch(getExpenseNotifications({ pageNumber: 1, pageSize: 10 }));
  }, []);
  // useEffect(() => () => {
  //   dispatch(getExpenseNotificationsSuccess({} as ExpenseNotificationsData));
  //   dispatch(getExpenseNotifications({ pageNumber: 1, pageSize: 10 }));
  // }, []);

  const handleClear = (id: string) => {
    dispatch(clearExpenseNotification({ ExpenseId: id }));
  };

  useEffect(() => {
    if (isClearSuccess) {
      if (containerRef.current) {
        containerRef.current.scrollTop = 0;
      }
      setData([]);
      setPage(1);
      setHasMore(true);

      dispatch(getExpenseNotificationsSuccess({} as ExpenseNotificationsData));

      setTimeout(() => {
        dispatch(getExpenseNotifications({ pageNumber: 1, pageSize: 10 }));
        dispatch(resetClearSuccess());
      }, 0);
    }
  }, [isClearSuccess]);

  useEffect(() => {
    dispatch(setLoader(isClearNotificationLoading));
  }, [isClearNotificationLoading]);

  return (
    <div className="dropdown-content" ref={containerRef}>
      <div className="div-style_title">
        Expense Notifications
        {isExpNotificationsLoading && !isFetching && <CircularProgress size={20} thickness={4} sx={{ color: '#ffffff !important' }} />}
      </div>
      <ul className="ul-style">
        <li>
          {data?.map((item) => (
            <>
              <div className="div2">
                <div>
                  <MessageIcon />
                </div>
                <div className="profile">
                  <span>{item?.AnalystName}</span>
                  {' '}
                  has sent an Expense Report for
                  {' '}
                  <span>{item?.JobOrder}</span>
                  {' '}
                  dated
                  {' '}
                  <span>{formatDateToMMDDYY(item?.Date || '')}</span>
                </div>
              </div>
              <div className="clear-div" onClick={() => handleClear(item?.Id)}>
                Clear
              </div>
            </>
          ))}
        </li>
      </ul>
      {isFetching && (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '12px 0',
        }}
      >
        <CircularProgress size={28} thickness={4} sx={{ color: '#00A751 !important' }} />
      </div>
      )}
    </div>
  );
}

export default ScreenExpenseNotification;
